import { userPool } from '@/lib/cognito';
import type { CognitoUserSession } from 'amazon-cognito-identity-js';

type HeadersRecord = Record<string, string>;

async function getRawIdToken(): Promise<string> {
  return new Promise((resolve, reject) => {
    const cognitoUser = userPool.getCurrentUser();

    if (!cognitoUser) {
      reject(new Error('User not authenticated'));
      return;
    }

    cognitoUser.getSession((err: Error | null, session: CognitoUserSession | null) => {
      if (err || !session || !session.isValid()) {
        reject(new Error('User session is invalid'));
        return;
      }
      resolve(session.getIdToken().getJwtToken());
    });
  });
}

function normalizeHeaders(headers?: HeadersInit): HeadersRecord {
  if (!headers) {
    return {};
  }

  if (headers instanceof Headers) {
    const normalized: HeadersRecord = {};
    headers.forEach((value, key) => {
      normalized[key] = value;
    });
    return normalized;
  }

  if (Array.isArray(headers)) {
    return headers.reduce<HeadersRecord>((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
  }

  return { ...headers };
}

async function bearerFetch(url: string, options: RequestInit = {}): Promise<Response> {
  const idToken = await getRawIdToken();
  const headers = normalizeHeaders(options.headers);

  headers.Authorization = `Bearer ${idToken}`;

  return fetch(url, {
    ...options,
    headers,
  });
}

export async function apiFetch(url: string, options: RequestInit = {}): Promise<Response> {
  return bearerFetch(url, options);
}
